/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'warning': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" _fill="none" _stroke="#FB3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M16 2l16 27H0z"/><path pid="1" _fill="#FB3" d="M14.5 11h3L17 21h-2z"/><circle pid="2" _fill="#FB3" cx="16" cy="24" r="2"/>'
  }
})
